import styled from 'styled-components';

export const RostersContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

export const PageTitle = styled.h1`
  color: var(--primary);
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const PageSubtitle = styled.p`
  color: var(--gray);
  text-align: center;
  margin: 0 0 2rem;
`;

export const SeasonSelector = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 320px;
  margin: 0 auto 1.5rem;

  label {
    color: var(--primary);
    font-weight: 600;
    text-align: center;
  }
`;

export const SeasonSelect = styled.select`
  width: 100%;
  border: 1px solid #cfd8dc;
  border-radius: 8px;
  padding: 0.65rem 0.75rem;
  font-size: 0.95rem;
  background: #fff;
  color: #263238;
`;

export const LoadingState = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: var(--gray);
`;

export const ErrorState = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: #c62828;
`;

export const NoPlayersState = styled.div`
  text-align: center;
  padding: 1.5rem 1rem;
  color: var(--gray);
`;

export const PlayersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.25rem;
`;

export const PlayerHeroCard = styled.article`
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #eceff1;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
  }

  transition: transform 0.15s ease;

  img {
    width: 100%;
    height: 280px;
    object-fit: cover;
    background-color: #f5f5f5;
  }

  .card-content {
    padding: 1rem;
  }

  .player-name {
    margin: 0 0 0.5rem;
    color: var(--primary);
    font-size: 1.15rem;
  }

  .player-meta {
    margin: 0;
    color: var(--gray);
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;
